import { render, staticRenderFns } from "./order-table.vue?vue&type=template&id=cf80e7ca&scoped=true&"
import script from "./order-table.vue?vue&type=script&lang=js&"
export * from "./order-table.vue?vue&type=script&lang=js&"
import style0 from "./order-table.vue?vue&type=style&index=0&id=cf80e7ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf80e7ca",
  null
  
)

export default component.exports